import styled from 'styled-components';
import { AppStyledProps } from '../../../../../types';

type T = AppStyledProps;

export const HeaderStyled = styled.div<T>`
  .close-modal {
    right: 10px;
    position: absolute;
    color: white;
  }
`;
